import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";

import useOrderStatusHandler from "./useOrderStatusHandler";

import { useTournamentRegistrationsContext } from "../contexts/TournamentRegistrations";

import {
    currencyFormat,
    defaultDateFormat,
    defaultDateTimeFormat,
} from "../../../../../lib/utils";
import { IOrder, IOrderProduct } from "../../../../../types/api";

const useTableHandler = () => {
    const { tournaments, masterTournaments, fetchStatus } =
        useTournamentRegistrationsContext();
    const { handleStatusChange } = useOrderStatusHandler();

    const generateTableRow = (o: IOrder, p: IOrderProduct, idx: number) => {
        const tournamentName = p?.description
            .replace(/\s*\d{1,2}[Uu]$/, "")
            .trim();
        const masterTournament = masterTournaments.find(
            t => t.name === tournamentName,
        );
        const tournament = tournaments.find(
            t => t.parent === masterTournament?.id && t.ageLevel === p?.name,
        );

        const popover = (
            <Popover className="orderNotes" key={`${o.id}-notes`}>
                <Popover.Body>{o.notes}</Popover.Body>
            </Popover>
        );

        return (
            <tr key={idx}>
                <td>{o.id}</td>
                <td>{defaultDateTimeFormat.format(new Date(o.date))}</td>
                <td>{o.status === "completed" ? "Paid" : "Unpaid"}</td>
                <td>
                    {o.completionDate ? (
                        defaultDateFormat.format(new Date(o.completionDate))
                    ) : (
                        <Button
                            onClick={() =>
                                handleStatusChange(o.id, "completed")
                            }
                            disabled={fetchStatus === "pending"}
                        >
                            Mark Paid
                        </Button>
                    )}
                </td>
                <td>
                    {p &&
                        `${tournamentName} - ${masterTournament?.designation}`}
                </td>
                <td>{o.user.name}</td>
                <td className="emailColumn">
                    {o.user.email.split("@").map((part, index) => (
                        <React.Fragment key={index}>
                            {part}
                            {index === 0 ? <span>@&#8203;</span> : null}
                        </React.Fragment>
                    ))}
                </td>
                <td>{p && p.meta.teamName}</td>
                <td>{p && p.name}</td>
                <td>
                    {p?.meta.teamId &&
                    tournament?.schedulingData.noFriday.includes(p?.meta.teamId)
                        ? "No"
                        : "Yes"}
                </td>
                <td>
                    {p
                        ? currencyFormat.format(p.orderPrice)
                        : currencyFormat.format(o.total)}
                </td>
                <td>{o.paymentType}</td>
                <td className="notes">
                    {o.notes ? (
                        <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={popover}
                        >
                            <span>Yes</span>
                        </OverlayTrigger>
                    ) : (
                        ""
                    )}
                </td>
                <td>
                    <Link
                        to={`/tournament-management/tournament-registrations/${o.id}`}
                        className="btn btn-primary"
                    >
                        View
                    </Link>
                </td>
            </tr>
        );
    };

    return { generateTableRow };
};
export default useTableHandler;
